import { OverlayHoverMessage, OverlayHoverMessageProps, OverlayHoverMessageRef } from "@kalyzee/kast-web-sdk/web-components";
import React, { ForwardedRef } from "react";
import styles from "./OverlayInformationMessage.module.css";

export interface OverlayInformationMessageProps extends Omit<OverlayHoverMessageProps, "ref"> {
  background?: string;
}

export interface OverlayInformationMessageRef extends OverlayHoverMessageRef {}

const OverlayInformationMessage = React.forwardRef(
  ({ background, ...nativeProps }: OverlayInformationMessageProps, forwardRef: ForwardedRef<OverlayInformationMessageRef | undefined>) => {
    const classes = [styles.default];
    if (nativeProps?.className) classes.push(nativeProps.className);
    const style: any = Object.assign({}, nativeProps?.style ?? {});
    if (background) style['--hover-message-background-color'] = background;
    return <OverlayHoverMessage ref={forwardRef} delay={1000} icon={null} {...nativeProps} style={style} className={classes.join(" ")} />;
  }
);

export default OverlayInformationMessage;
